import React, { useState } from 'react';
import { Select } from 'antd';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Modal from 'common/components/modal';
import { invoicingFrequencies } from '~constants/landlord';
import useStyles from '../../style';

const EditDetailsModal = props => {
  const [loading, setLoading] = useState(false);
  const { visible, onCancel, form, landlord, updateLandlord, getLandlord } = props;
  const { invoicingFrequency, purchaseOrderRequired } = landlord;

  const { getFieldDecorator, validateFields, resetFields } = form;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleCancel = () => {
    onCancel();
    resetFields(['invoicingFrequency', 'purchaseOrderRequired']);
  };
  const onOk = () => {
    validateFields((error, values) => {
      if (!error) {
        const { invoicingFrequency, purchaseOrderRequired } = values;
        setLoading(true);
        updateLandlord(
          {
            id: landlord.id,
            invoicingFrequency,
            purchaseOrderRequired,
          },
          () => {
            setLoading(false);
            onCancel();
            getLandlord();
          },
          () => {
            setLoading(false);
          },
        );
      }
    });
  };

  return (
    <>
      <Modal
        title={t('cms.landlord.invoice_info.setting_details_modal')}
        width={454}
        visible={visible}
        okText={t('cms.properties.edit.leave_alert.title')}
        cancelText={t('cms.landlord.modal.cancel.button')}
        wrapClassName={classes.modalWrapper}
        onCancel={handleCancel}
        onOk={onOk}
        cancelButtonProps={{
          className: 'ant-btn-cancel',
        }}
        okButtonProps={{
          loading,
          className: 'ant-btn-confirm',
        }}
      >
        <Form className={classes.formWrapper}>
          <Form.Item label={t('cms.landlord.detail.purchase_order_required.label')}>
            {getFieldDecorator('purchaseOrderRequired', {
              initialValue: purchaseOrderRequired,
            })(
              <Select placeholder={t('cms.landlord.modal.not_specific.placeholder')}>
                <Select.Option value={true}>{t('cms.form.value.yes')}</Select.Option>
                <Select.Option value={false}>{t('cms.form.value.no')}</Select.Option>
              </Select>,
            )}
          </Form.Item>

          <Form.Item label={t('cms.landlord.detail.invoicing_frequency.label')}>
            {getFieldDecorator('invoicingFrequency', {
              initialValue: invoicingFrequency ? invoicingFrequency.toUpperCase() : undefined,
            })(
              <Select placeholder={t('cms.landlord.modal.not_specific.placeholder')}>
                <For of={invoicingFrequencies} each="option" index="index">
                  <Select.Option key={index} value={option}>
                    {t(`cms.landlord.modal.${option.toLowerCase()}.option`)}
                  </Select.Option>
                </For>
              </Select>,
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
EditDetailsModal.propTypes = {
  form: PropTypes.object.isRequired,
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default Form.create()(EditDetailsModal);
